import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: "帐号注册",
    },
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/login/success',
    name: 'login_success',
    meta: {
      title: "帐号注册成功",
    },
    component: () => import('@/views/success/index.vue')
  },
  {
    path: '/download',
    name: 'download',
    meta: {
      title: "下载APP",
    },
    component: () => import('@/views/download/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
